import { render, staticRenderFns } from "./DocumentsSynthesisQuestion.vue?vue&type=template&id=195016c4"
import script from "./DocumentsSynthesisQuestion.vue?vue&type=script&lang=ts"
export * from "./DocumentsSynthesisQuestion.vue?vue&type=script&lang=ts"
import style0 from "./DocumentsSynthesisQuestion.vue?vue&type=style&index=0&id=195016c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports